export default (phoneNumber) => {
	if (!phoneNumber) return phoneNumber

	const cleanPhoneNumbers = phoneNumber.replace(/[^0-9]/gi, '')

	if (cleanPhoneNumbers.length < 10 || cleanPhoneNumbers.length > 11) return cleanPhoneNumbers

	const maskRegex = cleanPhoneNumbers.length === 11 ? /^([0-9]{2})([0-9]{5})([0-9]{4})$/ : /^([0-9]{2})([0-9]{4})([0-9]{4})$/

	const [, ddd, firstNumbers, lastNumbers] = cleanPhoneNumbers.match(maskRegex)
	let newPhoneNumber = `(${ddd}) ${firstNumbers}-${lastNumbers}`

	return newPhoneNumber
}
